/** Disambiguate visually identical names without changing the selected brand ID. */
export function brandSelectionLabel(brand: { id: string; name: string }, brands: readonly { id: string; name: string }[]): string {
  const name = brand.name.trim().toLowerCase();
  return brands.some(other => other.id !== brand.id && other.name.trim().toLowerCase() === name)
    ? `${brand.name} — ${brand.id}`
    : brand.name;
}
